import { Component, computed, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { select, Store } from '@ngxs/store';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import {
  CloneForm,
  CloneFormLibrary,
  LoadFormLibrariesForTenant,
} from '../../state/forms-library.actions';
import { CloneCustomFormBehaviourEnum } from '../../models/clone-form-request.model';
import { FormsLibraryState } from '../../state/forms-library.state';

@Component({
  selector: 'app-clone-form',
  templateUrl: './clone-form.component.html',
  styleUrls: ['./clone-form.component.scss'],
  standalone: false,
})
export class CloneFormComponent implements OnInit {
  tenant = new FormControl('', Validators.required);
  library = new FormControl('', Validators.required);

  private readonly allTenants = select(TenantUserAccessState.getAllAvailableTenants);
  readonly tenants = computed(() =>
    (this.allTenants() ?? []).filter((tenant) => tenant.id !== getTenantId())
  );

  getFormsLibraries = select(FormsLibraryState.getFormLibrariesForTenant);
  isLibrary = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { libraryId: string; customFormId: string },
    private store: Store
  ) {}

  ngOnInit(): void {
    this.isLibrary = !!this.data.libraryId;
  }

  onTenantChange(): void {
    this.store.dispatch(new LoadFormLibrariesForTenant(this.tenant.value ?? ''));
  }

  copy(): void {
    if (this.isLibrary) {
      this.store.dispatch(
        new CloneFormLibrary({
          sourceLibraryId: this.data.libraryId,
          targetTenantId: this.tenant.value as string,
          duplicateFormLibraryBehaviour: CloneCustomFormBehaviourEnum.AddMigratedPrefix,
        })
      );
    } else {
      this.store.dispatch(
        new CloneForm({
          customFormId: this.data.customFormId,
          targetTenantId: this.tenant.value as string,
          targetLibraryId: this.library.value ?? '',
          duplicateCustomFormBehaviour: CloneCustomFormBehaviourEnum.AddMigratedPrefix,
          duplicateFormLibraryBehaviour: CloneCustomFormBehaviourEnum.AddMigratedPrefix,
        })
      );
    }
  }
}
